import Layout from "components/layout";
import { AppHeader } from "components/layout/Header";
import { Heading } from "features/無料占いコンテンツ/components/atoms/Heading";
import { Text } from "features/無料占いコンテンツ/components/atoms/Text";
import Body from "features/無料占いコンテンツ/components/layout/Body";
import { BreadCrumb } from "features/無料占いコンテンツ/components/molecules/BreadCrumb";
import ContentsCard from "features/無料占いコンテンツ/components/organisms/ContentsCard";
import { NextSeo } from "next-seo";
import { useRouter } from "next/router";
import { ReactNode } from "react";
import { useFreeFortuneCategory } from "repositories/hooks";
import { useFreeFortuneContentList } from "repositories/hooks/useFreeFortuneContentList";
import { Loading } from "shared/components/templates/Loading";

const CategoryIndex = () => {
  const { query } = useRouter();
  const { freeFortuneContents, isLoading: isContentListLoading } =
    useFreeFortuneContentList({
      categoryId: query.categoryId as string,
    });

  const { freeFortuneCategory, isLoading: isCategoryLoading } =
    useFreeFortuneCategory(parseInt(query.categoryId as string));

  const title = `${freeFortuneCategory?.name}占い`;
  const description = freeFortuneCategory?.description?.replace(
    /embedding/g,
    "生年月日占いやタロット占いで完全無料鑑定！"
  );

  return (
    <>
      <Body>
        <NextSeo
          title={`${title} | 当たると評判のMIROR無料占い`}
          description={description}
        />
        <BreadCrumb
          freeFortuneCategory={freeFortuneCategory}
          tw="pt-[10px] px-4"
        />
        <div tw="px-4 my-5">
          {isCategoryLoading ? (
            <Loading loading />
          ) : (
            <>
              <Heading tw="my-5">{title}</Heading>
              <Text tw="my-5">{description}</Text>
            </>
          )}
        </div>
        {isContentListLoading ? (
          <Loading loading />
        ) : (
          <div tw="bg-gray py-2.5">
            {freeFortuneContents.map((content) => (
              <ContentsCard key={content.id} freeFortuneContent={content} />
            ))}
          </div>
        )}
      </Body>
    </>
  );
};

CategoryIndex.getLayout = (page: ReactNode) => {
  return <Layout header={<AppHeader> </AppHeader>}>{page}</Layout>;
};

export default CategoryIndex;
